import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SelezionaComprensorio from "../components/selezionacomp";
import UserForm from "../components/userform";
import "../components/loginform.css";
import { API_BASE } from "../utils/draftutils"; // <<< URL base backend

function RegisterUser() {
  const [comprensori, setComprensori] = useState([]);
  const [comprensorioSelezionato, setComprensorioSelezionato] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/comprensori`, {
          credentials: "include",
        });
        if (!res.ok) throw new Error("Errore durante la chiamata API");
        const data = await res.json();
        setComprensori(data);
      } catch (e) {
        setMessage("Errore durante il caricamento dei comprensori.");
      }
    })();
  }, []);

  const handleSelect = (comprensorio) => {
    setComprensorioSelezionato(comprensorio);
    setShowForm(true);
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_BASE}/api/auth/fru-register`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username,
          password,
          email,
          comprensorioNome: comprensorioSelezionato?.nome,
        }),
      });

      if (res.ok) {
        setMessage("Registrazione avvenuta con successo.");
        navigate("/", {
          replace: true,
          state: { successMessage: "Registrazione avvenuta con successo" },
        });
      } else {
        const msg = await res.text();
        setMessage(msg || "Registrazione non riuscita.");
      }
    } catch {
      setMessage("Errore di rete o server non raggiungibile.");
    }
  };

  return (
    <div className="bg-body-tertiary min-vh-100">
      <div className="py-4">
        <h2 className="fancy-title text-center" style={{ color: "black" }}>
           REGISTRAZIONE FRUITORE 
        </h2>

        <div className="container mt-4">
        {!showForm ? (
          <>
            <p className="fs-5 text-center mt-4">
              Seleziona il comprensorio geografico di tua appartenenza
            </p>
            <SelezionaComprensorio
              comprensori={comprensori}
              onSelect={handleSelect}
              showSelectButton={true}
            />
          </>
        ) : (
          <UserForm
            comprensorio={comprensorioSelezionato}
            email={email}
            username={username}
            password={password}
            onEmailChange={setEmail}
            onUsernameChange={setUsername}
            onPasswordChange={setPassword}
            onSubmit={handleSubmit}
          />
        )}
        </div>
      </div>
    </div>
  );
}

export default RegisterUser;
